import { connect } from 'react-redux';
import { fetchAllApiKeys, setContextualSupport, unsetContextualSupport } from '../../actions';
import { getVisibleAPIKeys } from '../../reducers/selectors';
import { GET_ALL_API_KEYS_REQUEST } from '../../constants/actionTypes';
import { SearchFilterViews } from '../../constants/visibilityFilters';
import UIUtils from '../../lib/UIUtils';
import ViewAPIKeys from './ViewAPIKeys';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import * as OLD_PATHS from 'js/constants/pathnames';

const mapStateToProps = (state, ownProps) => {
  const {
    app: {
      visibilityFilters: { filters },
    },
    request,
  } = state;
  const apiKeyId = UIUtils.extractParamFromURL(ownProps.match);

  return {
    apiKeyId,
    apiKeys: getVisibleAPIKeys(state),
    filters: filters[SearchFilterViews.API_KEYS],
    isLoading: !!request[GET_ALL_API_KEYS_REQUEST],
  };
};

const ViewAPIKeysContainer = connect(mapStateToProps, {
  fetchAllApiKeys,
  setContextualSupport,
  unsetContextualSupport,
})(ViewAPIKeys);

ViewAPIKeysContainer.screenConfig = {
  screenName: 'ViewAPIKeysContainer',
  domain: 'integrate',
  path: [`${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_API_KEYS}`],
  exact: true,
  pageTitle: 'API Keys',
  header: {
    title: 'API Keys',
    slugTitle: 'API Keys',
  },
  defaultProps: {
    onlyTableView: true,
  },
};

export default ViewAPIKeysContainer;
